import { Flex, Icon, Text, Tooltip, useToast, Input } from '@chakra-ui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { z } from 'zod'
import { api } from '../../../services/api'
import { Button } from '../../../components/Button'
import { BsArrowClockwise } from 'react-icons/bs'
import { useEffect } from 'react'

const schema = z.object({
    valorFreteDestacaNota: z.string().transform((value) => {
        return parseFloat(value)
    }),
    numeroNota: z.string().nonempty(),
})

const salvarFreteDestacaNota = async ({ valorFreteDestacaNota, numeroNota }) => {
    const response = await api.put('/site/v2/orcamento-crm/atualiza-valor-frete', {
        valor_frete: valorFreteDestacaNota,
        numero_pedido: numeroNota,
    })

    return response.data
}

export function Transportadora({ numeroNota, transportadora }) {
    console.log('transportadora', transportadora)
    const isDestacaFreteGratis = transportadora.frete_gratis && transportadora.destacar_nota

    const defaultValueFrete = !transportadora.frete_gratis || isDestacaFreteGratis ? parseFloat(transportadora.valor_simulacao).toFixed(2) : 0

    const queryClient = useQueryClient()
    const { handleSubmit, register, watch, setValue } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            valorFreteDestacaNota: parseFloat(transportadora.valor_simulacao).toFixed(2),
        },
    })

    const valorFrete = watch('valorFreteDestacaNota')

    const toast = useToast({
        status: 'success',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
    })

    const { mutateAsync, isLoading } = useMutation({
        mutationFn: salvarFreteDestacaNota,
        onSuccess: () => {
            toast({
                title: 'Frete destacado com sucesso!',
                description: 'O frete foi destacado na nota.',
                status: 'success',
            })

            queryClient.setQueryData(['items', numeroNota], (oldData) => {
                return {
                    ...oldData,
                    informacao_da_proposta: {
                        ...oldData.informacao_da_proposta,
                        transportadora: {
                            ...oldData.informacao_da_proposta.transportadora,
                            valor_simulacao: valorFrete,
                            destacar_nota: true,
                        },
                    },
                }
            })
        },
        onError: () => {
            toast({
                title: 'Erro ao destacar frete',
                description: 'Ocorreu um erro ao destacar o frete na nota.',
                status: 'error',
            })
        },
    })

    async function onSubmit(data) {
        console.log(data)
        await mutateAsync({
            valorFreteDestacaNota: data.valorFreteDestacaNota,
            numeroNota: data.numeroNota,
        })
    }

    useEffect(() => {
        setValue('valorFreteDestacaNota', transportadora.valor_simulacao)
    }, [transportadora.valor_simulacao, setValue])

    return (
        <Flex alignItems="center" gap={1} as="form" onSubmit={handleSubmit(onSubmit)}>
            <Tooltip label={`Transportadora: ${transportadora.nome_transportadora}`}>
                <Text maxW="189px" isTruncated>
                    Transp: <strong>{transportadora.nome_transportadora}</strong>
                </Text>
            </Tooltip>
            |<Text>{transportadora.prazo} dias úteis</Text>| {/* <Text>{formatPrice(transportadora.valor_simulacao)}</Text> */}
            Valor: <Input id="valorFreteDestacaNota" width="60px" {...register('valorFreteDestacaNota')} size="sm" borderRadius="0" />
            <input type="hidden" {...register('numeroNota', { value: numeroNota })} />
            <Button size="sm" type="submit" isLoading={isLoading}>
                <Icon as={BsArrowClockwise} fontSize="20px" />
            </Button>
        </Flex>
    )
}
